import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { IUserRole } from '@account-users/user/models/UserRole';
import { User } from '@account-users/user/models/User';
import { Permission } from '@account-users/account/models/Permission';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
  @Input() user: User;
  @Input() accountId: string;
  @Input() isUpdatingRole: boolean;
  @Input() userPermissions: Permission[] = [];
  @Input() userRoles: IUserRole[] = [];
  @Output() updateUserRoles = new EventEmitter<string>();

  onUpdateUserRoles(role: string) {
    this.updateUserRoles.emit(role);
  }
}
